import { useSelector } from "react-redux";
import { useParams, useNavigate, Outlet } from 'react-router-dom';
import { Box } from "@mui/material";
import DocumentsMain from "../components/Documents/DocumentsMain";

const Documents = () => {
	console.log('Documents component rendering...'); // Log component mount
	const { uuid } = useParams();
	console.log(`Documents component - UUID from useParams: ${uuid}`); // Log the detected uuid
	const ideaId = useSelector((state) => state?.explore?.idea?.id);
	const navigate = useNavigate(); // Get navigate function

	// Function to navigate to the wizard page
	const navigateToWizard = (docusignId) => {
		// Navigate to the wizard page using the docusignId
		navigate(`/Documents/Wizard/${docusignId}`);
	};

	return (
		<Box
			sx={{
				display: "flex",
				flex: 1,
				paddingTop: "0.5rem", // Added top padding
				gap: "15px",
				flexDirection: "column",
			}}
		>
			{/* DocumentsMain will now handle rendering DocumentDetailPage based on uuid */}
			<DocumentsMain
				ideaId={ideaId}
				uuid={uuid} // Pass uuid down
				navigateToWizard={navigateToWizard} // Pass the function down
			/>
			<Outlet context={{ navigateToWizard, ideaId }} />
		</Box>
	);
};

export default Documents;
